<template>
  <div v-if="ssoappid">
    <script>window.location.reload(false);</script>
    <span>跳转中，请稍候……</span>
  </div>
  <div v-else class="homeWrapper">
    <div class="header">
      <span class="headerTitle"></span> 有此标识的仅限在公司内部或VPN访问
    </div>
    <div class="mainWrapper">
      <div class="partWrapper" v-for="(item, index) in data" :key="index">
        <p>{{ item.classification }}</p>
        <div class="partItemWrapper">
          <div
            class="partItem"
            @click="jump(elm)"
            v-for="(elm, _index) in item.data.filter(e=>e.isShow)"
            :key="_index"
          >
            <div class="isLock" v-if="elm.isVpn"></div>
            <div class="logo">
              <img :src="require('../../assets/images/logos/' + elm.logo)" alt />
            </div>
            <div class="name">{{ elm.name }}</div>
          </div>
        </div>
      </div>
      <div class="footer">
        <p>报告问题联系方式</p>
        <p></p>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "@/utils";
import Axios from "axios";
const urlStr = "https://portal.longtubas.com";
export default {
  components: {},
  data() {
    return {
      data: [],
      user: {},
      ssoappid: null
    };
  },
  beforeCreate() {},
  created() {
    this.getUser();
    this.getData();
    this.ssoappid = window.localStorage.getItem("ssoappid");
    //此次请求为跳转URL，故 ssologin 参数为空
    if(window.localStorage.getItem("jump_url2") != null && window.localStorage.getItem("qyvx_email") != null) {
      this.ssologin(null);
    }
  },
  mounted() {},
  methods: {
    getUser() {
      //判断code
      const code = utils.getSearchParams("code");
      const emailCode = window.localStorage.getItem("qyvx_email");
      if (!code && ((!emailCode || emailCode === "undefined"))) {
        //TODO: 网页授权跳转url
        Axios(`${urlStr}/api/get/web/url`).then(response => {
          window.location.href = response.data.data;
          return false;
        });
      } else if (!emailCode || emailCode === "undefined") {
        Axios({
          url: `${urlStr}/api/get/user/info`,
          method: "POST",
          data: { code }
        }).then(response => {
          this.user = response.data.data;
          //TODO: email 存到客户端缓存
          window.localStorage.setItem("qyvx_email", this.user.email);
        });
      }
    },
    getData() {
      Axios("/data.json").then(myJson => {
        this.data = myJson.data.data;
      });
    },
    ssologin(elm) {
      let emailStr = window.localStorage.getItem("qyvx_email");
      const appid = (elm == null ? window.localStorage.getItem("ssoappid") : elm.appid);

      Axios(
        `${urlStr}/api/get/sso/url?appid=${appid}&email=${emailStr}`
      ).then(response => {
        //TODO: 拼接参数，跳转到sso
        const jump_url2 = window.localStorage.getItem("jump_url2");

        let sso_jump_url = response.data.data.sso_jump_url;

        if(jump_url2 != null) { //此次请求为跳转URL
          sso_jump_url = sso_jump_url.replace(/&code=/, "&callback_url=" + jump_url2 + "&code=");
          // window.prompt("sso_jump_url", sso_jump_url);
        }
        
        //清除此次URL跳转内容
        window.localStorage.removeItem("ssoappid");
        window.localStorage.removeItem("jump_url2");
        
        window.location.href = sso_jump_url;
        return false;
      });
    },
    jump(elm) {
      if (!elm.appid) {
        window.location.href = elm.url;
        return false;
      } else {
        this.ssologin(elm);
      }
    }
  },
  computed: {}
};
</script>

<style lang="scss" scoped>
@import "./home.scss";
</style>
